import { render, staticRenderFns } from "./DayAvailability.vue?vue&type=template&id=5f8e133d&scoped=true"
import script from "./DayAvailability.vue?vue&type=script&lang=js"
export * from "./DayAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e133d",
  null
  
)

export default component.exports